import { Component, HostListener, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { LayoutService } from './layout/service/app.layout.service';
import { AuthService } from './shared/services/auth.service';
import { BaseResponse } from './shared/models/base-response.model';
import { FirebaseNotificationService } from './shared/services/firebase-notification.service';
import { ReloadService } from './shared/services/reload.service';
import { NotificationService } from './shared/services/notification.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
    //System variables
    private ngUnsubscribe = new Subject<void>();

    constructor(
        private primengConfig: PrimeNGConfig,
        private layoutService: LayoutService,
        private authService: AuthService,
        private fcmService: FirebaseNotificationService,
        private reloadService: ReloadService,
        private notificationService: NotificationService,
    ) {}

    ngOnInit() {
        // firebase notification
        this.fcmService.currentMessage
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((message) => {
                if (message) {
                    this.notificationService.showInfoWithLife(
                        `🔔 ${message['notification']?.title}: 
                        ${message['notification']?.body}`,
                        10000,
                    );

                    // gửi thông báo cho notification component load lại trang
                    this.reloadService.triggerReload();
                }
            });

        // config primeng layout
        this.primengConfig.ripple = true;
        document.documentElement.style.fontSize = '12px';

        // optional configuration with the default configuration
        this.layoutService.config = {
            ripple: false, //toggles ripple on and off
            inputStyle: 'outlined', //default style for input elements
            menuMode: 'overlay', //layout mode of the menu, valid values are "static" and "overlay"
            colorScheme: 'light', //color scheme of the template, valid values are "light" and "dark"
            theme: 'tailwind-light', //default component theme for PrimeNG
            scale: 14, //size of the body font size to scale the whole application
        };
    }

    // @HostListener('window:beforeunload', ['$event'])
    // onBeforeUnload($event: any) {
    //     // call api logout user before tab close.
    //     this.authService.logoutServer().subscribe({
    //         next: (rs: BaseResponse<any>) => {
    //             if (rs.success) {
    //             } else {
    //             }
    //         },
    //         error: (ex) => {},
    //     });
    // }

    // Sửa mã để out mỗi khi F5 trang
    @HostListener('window:beforeunload', ['$event'])
    onBeforeUnload($event: any) {
        // Kiểm tra xem hành động có phải là Reload (F5) hay không
        const isReload =
            window.performance &&
            window.performance.navigation &&
            window.performance.navigation.type === 1;
        const isReloadV2 =
            window.performance.getEntriesByType('navigation')[0]?.['type'] ===
            'reload';

        if (isReload || isReloadV2) {
            // Nếu là F5 reload trang thì thoát ra, KHÔNG gọi API logout
            return;
        }

        // Chỉ gọi API logout khi thực sự tắt tab / tắt trình duyệt
        this.authService.logoutServer().subscribe({
            next: (rs: BaseResponse<any>) => {},
            error: (ex) => {},
        });
    }
}
